import React from "react";
import { Navigate } from "react-router-dom";


const ComingSoonRoute = () => {
 
  return <Navigate to="/coming-soon" />;
};

export default ComingSoonRoute;